import React, { Component } from 'react';
import { ProjectConsumer } from './providers/ProjectProvider';
import LanguageSelector from './LanguageSelector';
import PropTypes from 'prop-types';

class ProjectLanguageSelector extends Component {

  render() {

    const { includeLabel, selectedLang, multiple, excludeNoLanguage, hideOnOneLang, margin, disabled, excludeLangs } = this.props;

    return (
      <ProjectConsumer>
        {({ projectLang, defaultLang }) => (
          projectLang.length === 1 && hideOnOneLang ?
            null
            :
            <div style={{ marginRight: margin }}>
              <LanguageSelector
                includeLabel={includeLabel}
                multiple={multiple}
                disabled={disabled}
                autoFocus={false}
                excludeLangs={excludeLangs}
                excludeNoLanguage={excludeNoLanguage}
                langs={projectLang}
                defaultLang={defaultLang}
                selectedLang={selectedLang}
                onSelect={this.props.onSelect} />
            </div>
        )}
      </ProjectConsumer>
    );
  }
}

ProjectLanguageSelector.defaultProps = {
  multiple: false,
  hideOnOneLang: false,
  margin: '0px'
};

ProjectLanguageSelector.propTypes = {
  multiple: PropTypes.bool,
  hideOnOneLang: PropTypes.bool,
  excludeNoLanguage: PropTypes.bool,
  margin: PropTypes.string,
  disabled: PropTypes.bool,
  excludeLangs: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  selectedLang: PropTypes.string,
  includeLabel: PropTypes.bool
};

export default ProjectLanguageSelector;